import { render } from "./ValueCard.vue?vue&type=template&id=ca3c58b4"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__